import { StaffDashboard } from "./staff-dashboard";
import { ProfileSettings } from "./profile-settings";
import {StaffChat} from "./modules/staff-chat";
import { StaffAppointmentInfo } from "./modules/staff-appointment-info";
export { StaffDashboard, StaffChat, ProfileSettings, StaffAppointmentInfo };
